import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationen from './locales/en.json';

import translationid from './locales/id.json';

import translationzh_tw from './locales/zh-TW.json';


i18n

    .use(Backend)

    .use(LanguageDetector)

    .use(initReactI18next)

    .init({
        lng: 'id',
        fallbackLng: 'en',
        debug: false,

        interpolation: {
            escapeValue: false,
        },
        resources: {

            "en": {
                translation: translationen
            },

            "id": {
                translation: translationid
            },

            "zh-TW": {
                translation: translationzh_tw
            },

        }
    });


export default i18n;